import { CreatePostForm } from "./CreatePostForm";
export const CreatePost = () => {
  return (
    <div>
      <h1>Create post</h1>
      <CreatePostForm />
    </div>
  );
};
